import { cn } from "@/lib/utils";

/** documentStyle types a block of rendered markdown the way the legal pages read. */
export const documentStyle = cn(
  "text-foreground-pressed text-sm leading-relaxed",
  "[&_h1]:text-foreground [&_h1]:mb-8 [&_h1]:text-2xl [&_h1]:font-semibold",
  "[&_h2]:text-foreground [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-lg [&_h2]:font-semibold",
  "[&_h3]:text-foreground [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:font-semibold",
  "[&_p]:mb-4",
  // streamdown puts markers inside the box, so wrapped lines run under the bullet
  "[&_ul]:mb-4 [&_ul]:list-outside [&_ul]:pl-5",
  "[&_ol]:mb-4 [&_ol]:list-outside [&_ol]:pl-5",
  "[&_li]:py-0.5",
  "[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2",
  "[&_strong]:text-foreground [&_strong]:font-semibold",
);
